import React from 'react'
import { string, func } from 'prop-types'

import {
  ArrowLeft,
  ArrowRight,
  Close,
  Button,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import SvgIcon from 'Pods/Shared/SvgIcon'

function Action({ icon, onClick }) {

  const iconsMap = {
    Close: <Close />,
    ArrowLeft: <ArrowLeft />,
    ArrowRight: <ArrowRight />,
  }

  return (
    <Button
      type="secondary"
      variant="only-icon"
      onClick={onClick}
      icon={<SvgIcon>{iconsMap[icon]}</SvgIcon>}
    />
  )
}

Action.propTypes = {
  icon: string.isRequired,
  onClick: func.isRequired,
}

export default Action
